<template>
    <div v-if="agendas">
        <div :id="divname" v-show="false">
            <cabecalho-generico titulo="Agendas">
                <div>
                    Data: {{ lista_datas }}
                </div>
            </cabecalho-generico>

            <table class="table table-sm table-bordered small">
                <tbody>
                    <tr>
                        <th v-for="(lista_status, status, isx) in totalizador_status" :key="isx">
                            {{ status }}: {{ lista_status.length }} 
                            <div>
                                {{ Math.round( ( lista_status.length / total_geral ) * 100 ) }}%
                            </div>
                        </th>
                        <th>
                            Total: {{ total_geral }}
                        </th>
                        <th>
                            Atendidos: {{ totalizador_atendidos }}
                            <div>
                                {{ Math.round( ( totalizador_atendidos / totalizador_ocupados ) * 100 ) }}%
                            </div>
                        </th>
                    </tr>
                </tbody>
            </table>

            <table class="table table-sm small">
                <thead>
                    <tr>
                        <th>Hora</th>
                        <th>Paciente</th>
                        <th>Unid</th>
                        <th>Procedimento</th>
                        <th>Plano</th>
                        <th>Telefone</th>
                        <th>Atend</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(lista, grupo, idx) in agendas">
                        <tr :key="'T' + idx" v-if="true">
                            <th colspan="7">{{ grupo }}</th>
                        </tr>
                        <tr v-for="(item, iix) in ordenar(lista)" :key="'I-' + idx + '-' + iix">
                            <td>
                                {{ item.hora }}
                                <span v-if="item.marcacao && item.marcacao.in_slots && item.marcacao.in_slots > 1">
                                    ({{ item.marcacao.in_slots }})
                                </span>
                            </td>
                            <td>
                                <template v-if="!item.marcacao && item.status == 'bloqueado'">
                                    BLOQUEADO
                                </template>

                                <template v-else>
                                    {{ item.marcacao ? item.marcacao.nome_paciente : '' }}
                                    <span class="small ml-1" v-if="item.marcacao && item.marcacao.paciente && item.marcacao.paciente.cadastro && item.marcacao.paciente.cadastro.idade_anos && ( item.marcacao.paciente.cadastro.idade_anos || item.marcacao.paciente.cadastro.idade_anos === 0 )">
                                        {{ item.marcacao.paciente.cadastro.idade_anos }}a
                                    </span>  

                                    <span class="small ml-1" v-else-if="item.marcacao && item.marcacao.cadastro_temporario && ( item.marcacao.cadastro_temporario.id_a || item.marcacao.cadastro_temporario.id_a === 0 )">
                                    {{ item.marcacao.cadastro_temporario.id_a }}a
                                    </span>  
                                </template>
                            </td>
                            <td>
                                {{ ( item.marcacao && item.marcacao.unidade_operacao && item.marcacao.unidade_operacao.st_sigla ) ? item.marcacao.unidade_operacao.st_sigla : '' }}
                            </td>
                            <td>
                                {{ ( item.marcacao && item.marcacao.procedimento ) ? item.marcacao.procedimento.st_procedimento : '' }}
                            </td>
                            <td>
                                {{ 
                                    ( item.marcacao && item.marcacao.plano && item.marcacao.plano.search ) 
                                        ? item.marcacao.plano.search 
                                        : ( 
                                            ( item.marcacao && item.marcacao.plano && item.marcacao.plano.operadora && item.marcacao.plano.operadora.search ) 
                                                ? item.marcacao.plano.operadora.search 
                                                : ''
                                        )
                                }}
                            </td>
                            <td class="text-nowrap">
                                <template v-if="item.marcacao">
                                    <div class="d-flex justify-content-between" v-if="item.marcacao.paciente">
                                        <div v-if="item.marcacao.paciente.cadastro && item.marcacao.paciente.cadastro.telefone_cadastros">
                                            <div v-for="(tel, it) in item.marcacao.paciente.cadastro.telefone_cadastros" :key="it">
                                                <small>
                                                    {{ telefone(tel.telefone.st_numero, tel.telefone.st_cod_pais) }}
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="d-flex justify-content-between" v-else-if="item.marcacao.cadastro_temporario">
                                        <div>
                                            <div v-if="item.marcacao.cadastro_temporario.st_telefone">
                                                <small>
                                                    {{ telefone(item.marcacao.cadastro_temporario.st_telefone) }}
                                                </small>
                                            </div>
                                            <div v-if="item.marcacao.cadastro_temporario.st_celular">
                                                <small>
                                                    {{ telefone(item.marcacao.cadastro_temporario.st_celular, item.marcacao.cadastro_temporario.st_cod_pais) }}
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </td>
                            <td>
                                {{ ( item.marcacao && item.marcacao.id_atendimento ) ? item.marcacao.id_atendimento : '' }}
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import CabecalhoGenerico from '../../relatorios/shared/CabecalhoGenerico.vue';

export default {
    data() { 
        return { 
            agendas: null, 
            chave: "", 
        }
    },

    components: { 
        CabecalhoGenerico
    },

    computed: { 
        lista_datas: function() { 
            return _.uniqBy(_.flatMap(this.agendas), 'data').map(item => { 
                    return this.$util.getFormatDate(item.data);
                })
                .join(', ');
        },

        divname: function () { 
            return 'relatorio-agendas-' + this.chave; 
        },

        totalizador_status: function() { 
            return _.groupBy(_.flatMap(this.agendas), item => { 
                switch (item.status) {
                    case 'passado':
                    case 'livre':
                        return 'livre';
                }

                return item.status
            });
        },

        totalizador_ocupados: function () { 
            return _.filter(_.flatMap(this.agendas), item => { 
                return item.status == 'ocupado' ? true : false;
            }).length;
        },

        totalizador_atendidos: function () { 
            return _.filter(_.flatMap(this.agendas), item => { 
                return ( item.marcacao && item.marcacao.id_atendimento ) ? true : false;
            }).length;
        },

        total_geral: function () { 
            return _.flatMap(this.totalizador_status).length
        }
    },

    methods: {
        telefone (telefone, cod_pais = null) { 

            if ( cod_pais && cod_pais == '+' ) { 
                return cod_pais + telefone;
            }

            let numb = telefone.match(/\d/g);

            if ( !numb )
                return;

            numb = numb.join("");

            let textoAjustado = "";

            if ( numb.length == 8 ) {
                const parte1 = numb.slice(0,4);
                const parte2 = numb.slice(4,8);
                textoAjustado = textoAjustado + `${parte1}-${parte2}`;
            } else if ( numb.length == 9 ) {        
                const parte1 = numb.slice(0,5);
                const parte2 = numb.slice(5,9);
                textoAjustado = textoAjustado + `${parte1}-${parte2}`;
            } else { 
                textoAjustado = "(" + numb.slice(0,2) + ") ";
                if(numb.length == 11) {
                    const parte1 = numb.slice(2,7);
                    const parte2 = numb.slice(7,11);
                    textoAjustado = textoAjustado + `${parte1}-${parte2}`        
                } else {
                    const parte1 = numb.slice(2,6);
                    const parte2 = numb.slice(6,10);
                    textoAjustado = textoAjustado + `${parte1}-${parte2}`
                }
            }

            return textoAjustado;
        },

        ordenar(lista) {
            return _.orderBy(lista, ['hora'], ['asc']);
        },

        imprimir (agendas) { 
            this.agendas = _.cloneDeep(agendas);

            this.$nextTick(() => {
                this.$htmlToPaper(this.divname, null, () => {
                    console.log("Printing");
                });                
            });
        }      
    },
}
</script>
